import script from "./AltarHome.vue?vue&type=script&setup=true&lang=js"
export * from "./AltarHome.vue?vue&type=script&setup=true&lang=js"

import "./AltarHome.vue?vue&type=style&index=0&id=85e869c2&scoped=true&lang=css"
import "./AltarHome.vue?vue&type=style&index=1&id=85e869c2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85e869c2"]])

export default __exports__